import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Extrai mensagem de erro da resposta da API (Axios/HTTP) para exibir ao usuário */
export const getApiErrorMessage = (error: unknown): string => {
  if (!error || typeof error !== "object") return "Erro desconhecido";
  const err = error as { response?: { data?: { message?: string; errors?: Record<string, string> } }; message?: string };
  const msg = err.response?.data?.message;
  if (msg) return msg;
  const errors = err.response?.data?.errors;
  if (errors && typeof errors === "object") {
    const parts = Object.entries(errors).map(([k, v]) => `${k}: ${v}`);
    return parts.length > 0 ? parts.join("; ") : "Dados inválidos.";
  }
  return err.message || "Erro ao processar requisição.";
};

/** Mensagem amigável para erros de upload/rede (documentos, foto, etc.) */
export function getFriendlyUploadErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    const msg = error.message;
    const code = (error as { code?: string }).code;
    if (code === "ERR_NETWORK" || msg.includes("Network Error") || msg.includes("Failed to fetch")) {
      return "Erro de conexão. Verifique sua internet e tente novamente. Se usar outro domínio (ex.: API em subdomínio), confira CORS no servidor.";
    }
    if (msg.includes("Bucket") || msg.includes("bucket") || msg.includes("RLS") || msg.includes("Supabase")) {
      return "Erro ao enviar arquivo. Verifique se o bucket está criado e as políticas RLS no Supabase.";
    }
    return msg;
  }
  return "Erro ao enviar documento. Tente novamente.";
}
